<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="page-title">Quản lý Loại Xe (Gói Checklist)</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Dashboard</router-link></li>
              <li class="breadcrumb-item active">Loại Xe</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-body d-flex flex-wrap align-items-center gap-2">
          <div class="ml-auto d-flex align-items-center gap-2">
            <select class="form-control form-control-sm" style="width: auto" v-model.number="pageSize" @change="changeSize">
              <option :value="5">5</option>
              <option :value="10">10</option>
              <option :value="20">20</option>
            </select>
            <button class="btn btn-primary btn-sm" @click="openCreate">
              <i class="fa fa-plus"></i> Thêm Loại Xe
            </button>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body p-0">
          <div v-if="isLoading" class="p-4 text-center">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 mb-0">Đang tải dữ liệu...</p>
          </div>
          <div v-else>
            <div v-if="items.length === 0" class="p-4 text-center text-muted">
              Không có dữ liệu.
            </div>
            <div v-else class="table-responsive">
              <table class="table table-hover table-striped mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Tên Loại Xe</th>
                    <th>Mô tả</th>
                    <th>Số hạng mục</th>
                    <th>Trạng thái</th>
                    <th class="text-right" style="width: 120px;">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td><strong>{{ item.tenLoaiXe }}</strong></td>
                    <td>{{ item.moTa || '-' }}</td>
                    <td>
                      <span class="badge badge-info">{{ item.checklistItems?.length || 0 }}</span>
                    </td>
                    <td>
                      <span :class="['badge', item.active ? 'badge-success' : 'badge-danger']">
                        {{ item.active ? 'Đang hoạt động' : 'Tạm ngưng' }}
                      </span>
                    </td>
                    <td class="text-right">
                      <button class="btn btn-sm btn-outline-secondary mr-1" @click="openEdit(item)">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-danger" @click="confirmDelete(item)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div class="p-3 d-flex justify-content-between align-items-center border-top">
              <small class="text-muted">
                Tổng: {{ totalElements }} — Trang {{ currentPage }}/{{ totalPages }}
              </small>
              <ul class="pagination mb-0">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a href="#" class="page-link" @click.prevent="goPage(currentPage - 1)">Trước</a>
                </li>
                <li v-for="p in totalPages" :key="p" class="page-item" :class="{ active: p === currentPage }">
                  <a href="#" class="page-link" @click.prevent="goPage(p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                  <a href="#" class="page-link" @click.prevent="goPage(currentPage + 1)">Sau</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,.5);">
        <div class="modal-dialog modal-lg" role="document"> 
          <div class="modal-content">
            <form @submit.prevent="submitForm">
              <div class="modal-header bg-light">
                <h5 class="modal-title font-weight-bold">
                  {{ isEdit ? 'Cập nhật Loại Xe' : 'Thêm Loại Xe mới' }}
                </h5>
                <button type="button" class="close" @click="closeModal"><span>&times;</span></button>
              </div>
              <div class="modal-body">
                <div v-if="formError" class="alert alert-danger py-2">{{ formError }}</div>
                
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>Tên Loại Xe <span class="text-danger">*</span></label>
                      <input v-model.trim="form.tenLoaiXe" type="text" class="form-control" required autofocus>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Trạng thái</label>
                      <select v-model="form.active" class="form-control">
                        <option :value="true">Đang hoạt động</option>
                        <option :value="false">Tạm ngưng</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>Mô tả</label>
                  <textarea v-model.trim="form.moTa" class="form-control" rows="2"></textarea>
                </div>
                
                <hr>
                
                <div class="form-group">
                  <label class="font-weight-bold">Các Hạng mục Checklist</label>
                  <div v-if="isLoadingAllItems" class="text-center">
                    <div class="spinner-border spinner-border-sm"></div>
                    <span class="ml-2">Đang tải danh sách hạng mục...</span>
                  </div>
                  <div v-else-if="allActiveItems.length === 0" class="text-muted">
                    Không tìm thấy hạng mục nào. Vui lòng thêm Hạng mục Checklist trước.
                  </div>
                  <div v-else class="checklist-box" style="max-height: 300px; overflow-y: auto; border: 1px solid #ddd; padding: 10px; border-radius: 5px;">
                    <div v-for="item in allActiveItems" :key="item.id" class="form-check">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        :id="'item-' + item.id"
                        :value="item.id"
                        v-model="form.checklistItemIds"
                      >
                      <label class="form-check-label" :for="'item-' + item.id">
                        ({{ item.viTri || 'N/A' }}) {{ item.tenHangMuc }} 
                        <span :class="['badge', getMucDoClass(item.mucDo)]">{{ formatMucDo(item.mucDo) }}</span>
                      </label>
                    </div>
                  </div>
                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" @click="closeModal">Hủy bỏ</button>
                <button type="submit" class="btn btn-primary" :disabled="isLoading">
                  <span v-if="isLoading" class="spinner-border spinner-border-sm"></span>
                  {{ isEdit ? 'Lưu thay đổi' : 'Thêm mới' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-if="showDelete" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,.5);">
         <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Xoá Loại Xe</h5>
              <button type="button" class="close" @click="showDelete=false"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              Bạn chắc chắn muốn xoá loại xe <strong>{{ pendingDelete?.tenLoaiXe }}</strong>?
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-secondary" @click="showDelete=false">Huỷ</button>
              <button class="btn btn-danger" @click="doDelete"><i class="fa fa-trash"></i> Xoá</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'pinia';
// IMPORT CẢ 2 STORES
import { useDmLoaiXeStore } from '@/stores/dmLoaiXeStore';
import { useDmChecklistItemStore } from '@/stores/dmXeChecklistStore';

// Định nghĩa form mặc định (clean code)
const DEFAULT_FORM = {
  tenLoaiXe: '',
  moTa: '',
  active: true,
  checklistItemIds: [], // Dùng mảng để v-model với checkbox
};

export default {
  name: 'QuanLyLoaiXe',
  data() {
    return {
      showModal: false,
      isEdit: false,
      formError: null,
      form: { ...DEFAULT_FORM },
      showDelete: false,
      pendingDelete: null,
    };
  },
  computed: {
    // Map state của store "Loại Xe"
    ...mapState(useDmLoaiXeStore, ['isLoading', 'error', 'items', 'totalPages', 'totalElements', 'size']),
    ...mapGetters(useDmLoaiXeStore, ['currentPage']),
    
    // Map state của store "Hạng Mục" (để lấy list checkbox)
    ...mapState(useDmChecklistItemStore, {
      allActiveItems: 'allActiveItems',
      isLoadingAllItems: 'isLoadingAll',
    }),

    pageSize: {
      get() { return this.size; },
      set() { /* handled in changeSize */ }
    }
  },
  methods: {
    // Map actions của store "Loại Xe"
    ...mapActions(useDmLoaiXeStore, ['fetchList', 'setPage', 'setSize', 'createLoaiXe', 'updateLoaiXe', 'deleteLoaiXe']),
    
    // Map actions của store "Hạng Mục"
    ...mapActions(useDmChecklistItemStore, ['fetchAllActive']),

    // --- Helpers để hiển thị badge (Giống file QuanLyChecklistItem) ---
    formatMucDo(mucDo) {
      switch (mucDo) {
        case 'CRITICAL': return 'Nghiêm trọng';
        case 'WARNING': return 'Cảnh báo';
        case 'INFO': return 'Thông tin';
        default: return mucDo;
      }
    },
    getMucDoClass(mucDo) {
      switch (mucDo) {
        case 'CRITICAL': return 'badge-danger';
        case 'WARNING': return 'badge-warning';
        case 'INFO': return 'badge-info';
        default: return 'badge-secondary';
      }
    },
    
    changeSize() {
      this.setSize(Number(this.pageSize));
      this.fetchList();
    },
    goPage(p) {
      if (p < 1 || p > this.totalPages) return;
      this.setPage(p);
      this.fetchList();
    },

    openCreate() {
      this.isEdit = false;
      this.formError = null;
      this.form = { ...DEFAULT_FORM, checklistItemIds: [] }; // Reset form
      this.showModal = true;
    },

    openEdit(item) {
      this.isEdit = true;
      this.formError = null;
      // Copy thông tin cơ bản
      this.form = { 
        tenLoaiXe: item.tenLoaiXe,
        moTa: item.moTa,
        active: item.active,
      };
      // Lấy ID của các checklist đã gán từ (DmLoaiXeDto)
      this.form.checklistItemIds = (item.checklistItems || []).map(ci => ci.id);
      this.form._id = item.id; // Giữ ID để update
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    async submitForm() {
      this.formError = null;
      if (!this.form.tenLoaiXe) {
        this.formError = 'Tên Loại Xe là bắt buộc.';
        return;
      }

      try {
        // Build payload (giống DmLoaiXeRequestDto)
        const payload = {
          tenLoaiXe: this.form.tenLoaiXe,
          moTa: this.form.moTa,
          active: this.form.active,
          checklistItemIds: this.form.checklistItemIds, // Gửi mảng ID
        };

        if (this.isEdit) {
          await this.updateLoaiXe(this.form._id, payload);
        } else {
          await this.createLoaiXe(payload);
        }
        this.closeModal();
      } catch (e) {
        this.formError = e?.response?.data?.message || e?.message || 'Có lỗi xảy ra.';
      }
    },
    
    confirmDelete(item) {
      this.pendingDelete = item;
      this.showDelete = true;
    },

    async doDelete() {
      try {
        await this.deleteLoaiXe(this.pendingDelete.id);
        this.showDelete = false;
        this.pendingDelete = null;
      } catch (e) {
        alert(e?.response?.data?.message || e?.message || 'Xoá thất bại.');
      }
    },
  },
  mounted() {
    // Tải 2 danh sách song song
    this.fetchList(); // Tải danh sách Loại Xe (phân trang)
    this.fetchAllActive(); // Tải danh sách Hạng mục (cho modal)
  }
};
</script>

<style scoped>
.table td, .table th { vertical-align: middle; }
.modal { overflow-y: auto; }
/* Thêm style cho list checkbox */
.checklist-box .form-check {
  margin-bottom: 8px;
}
.checklist-box .form-check-label {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>